import { ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnChooserService, GridComponent, PageService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { ColumnChooser, DataStateChangeEventArgs, FilterSettingsModel, SelectionSettingsModel, SortSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ClickEventArgs } from '@syncfusion/ej2-navigations/src/toolbar/toolbar';
import { Tooltip } from '@syncfusion/ej2-popups';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AttributeStatusEnum, DataScopesEnum, MessageSeverityEnum, RegistrationTypeEnum, ValidationStatusEnum } from '../../shared/enums/index';
import { IRegistrationType, ISelectAll, IServerSettings, IUserPrefs } from '../../shared/models/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AuthorizationService, CustomerService, DeviceinventoryService, ExportDataService, SettingsService, StorageManagerService } from '../../shared/services/index';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { IPredicate, IQuery } from '../../shared/models/select-all.model';
import { Output, EventEmitter } from '@angular/core';
import { FeatureService } from '../../shared/services/feature.service';

@Component({
  selector: 'app-base-grid',
  templateUrl: './base-grid.component.html',
  styleUrls: ['./base-grid.component.scss'],
  providers: [ToolbarService, ColumnChooserService, PageService],
})
export class BaseGridComponent implements OnInit, OnDestroy, OnChanges {

  toolbar: ToolbarItems[] | object;
  selectedRecords: any[];
  selectedRows: any[];
  selectedItems: string[] = [];
  // excludedFromSelectAllItems: string[] = [];
  filterSettings: FilterSettingsModel;
  sortSettings: SortSettingsModel;
  pageOptions: Object;
  prefsPerGrid: any;
  selectionOptions: SelectionSettingsModel;
  columnChooser: ColumnChooser;
  appDefaults: IUserPrefs;
  subscription: Subscription;
  data: any;
  state: DataStateChangeEventArgs;
  error: string;
  deviceCount: number;
  pageItemCounter: any;
  dataScopeEudamed = false;
  dataScope: string;
  permissionsConst: any;
  initialLoad = true;
  selectAllChecked = false;
  // needed to keep track if the rows are deselected or originally unchecked.
  deselectAllChecked = false;
  selectedRowsCount = 0;
  validatedAll = false;
  submittedAll = false;
  timerInterval: any;

  queryObject: any;
  queryCriteria: ISelectAll = <ISelectAll>{};
  filterCriteria: string;
  action: string;

  dataScopeEnum = DataScopesEnum;
  validationStatusEnum = ValidationStatusEnum;
  attributeStatusEnum = AttributeStatusEnum;

  serverSettings: IServerSettings;

  public MessageSeverityEnum = MessageSeverityEnum;

  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('tooltipObj') tooltipObj: TooltipComponent;
  tooltipContent: HTMLElement;

  tooltip: Tooltip;

  @ViewChild('leadingTab') leadingTab: ElementRef;
  @Output() registrationTypeSelection = new EventEmitter<RegistrationTypeEnum>();
  public isLegacyImportFeatureEnabled: boolean = false;

  constructor (protected service: DeviceinventoryService,
    protected storage: StorageManagerService, protected router: Router, protected activatedRoute: ActivatedRoute,
    protected toastr: ToastrService, protected cdref: ChangeDetectorRef, protected authorizationService: AuthorizationService,
    protected authenicationService: AuthenticationService, protected appGlobals: AppGlobals,
    protected exportDataService: ExportDataService, protected settingsService: SettingsService,
    protected customerService: CustomerService, protected featureService: FeatureService) {

    this.data = service;
    this.serverSettings = this.settingsService.getSettings();
  }

  isEllipsisActive(e) {
    return (e.target.offsetWidth < e.target.scrollWidth);
  }

  ngOnChanges(changes: SimpleChanges) {

    const gridData: SimpleChange = changes.gridData;
    if (gridData && gridData.currentValue) {

      this.data = JSON.parse(gridData.currentValue);
    } else {

      this.error = 'External error';
    }
  }

  setDeviceCounter() {

    const pageCountMsg = document.getElementsByClassName('e-pagecountmsg')[0];

    if (pageCountMsg) {
      this.pageItemCounter = (pageCountMsg as any).innerText;

      this.deviceCount = this.pageItemCounter.substr(this.pageItemCounter.indexOf('(') + 1, this.pageItemCounter.indexOf(' item') - 1);
    } else {

      this.deviceCount = -1;
    }
  }

  ngOnInit() {

    this.permissionsConst = this.appGlobals.permissions;
    this.serverSettings = this.settingsService.getSettings();

    this.filterSettings = {
      type: 'Menu',
      operators: {
        stringOperator: [
          { value: 'contains', text: 'contains' },
          { value: 'startsWith', text: 'starts with' },
          { value: 'endsWith', text: 'ends with' },
          { value: 'equal', text: 'equal' }
        ],
        dateOperator: [
          { value: 'equal', text: 'equal' }
        ],
      }
    };

  }


  /**
* Every time the data state changes (resize, reorder, reload, etc.) this event gets triggered
* and originates the grid parameters. The parameter showInColumnChooser should be present
* for all columns in the columnOptions array. Default columns should be set to false to
* prevent the user from hiding them.
* Called from the html on the grid's dataStateChange event
* @param  {DataStateChangeEventArgs} state
* @returns void
*/
  public dataStateChange(state: DataStateChangeEventArgs): void {


  }

  dataBound(args: any) { }

  /**
    * Controls the ColumnChooser checkBox click event.
    * Called from the html beforeOpenColumnChooser event
    * @param  {any} args
    */
  checkboxClick(args: any) {

    setTimeout(function (e) {

      const dialogContents = document.getElementsByClassName('e-dlg-content')[0];
      const searchDiv = document.getElementsByClassName('e-cc-searchdiv')[0];
      const contentsDiv = document.getElementsByClassName('e-cc-contentdiv')[0];
      const ccDiv = document.getElementsByClassName('e-ccdlg e-cc')[0];
      const cancelButton = document.getElementsByClassName('e-cc-cnbtn')[0];
      const okButton = document.getElementsByClassName('e-cc_okbtn')[0];

      // since the load event added one more UL, use index 1 instead of 0
      const selectAllEl = document.getElementsByClassName('e-cc-selectall')[1];

      if (dialogContents) {
        (dialogContents.querySelector('.e-innerdiv') as HTMLElement).style.display = 'none';
      }


      if (contentsDiv) {
        contentsDiv.classList.add('columnChooserMarginTop');
      }

      if (okButton) {
        okButton.innerHTML = 'Apply';
      }

      if (cancelButton) {
        cancelButton.classList.add('column-chooser-cancel-button');
      }

      if (searchDiv) {
        searchDiv.classList.add('hidden');
      }

      if (selectAllEl) {
        selectAllEl.classList.add('hidden');
      }

      if (ccDiv) {
        ccDiv.classList.add('columnChooserExtraWidth');
      }

      if (this.requiredColumns && this.requiredColumns.length > 0) {

        // since the load event added one more UL, use index 1 instead of 0
        const sortedUL = dialogContents.querySelectorAll('ul')[1];

        this.requiredColumns.forEach(colName => {

          const liArray = sortedUL.querySelectorAll('li');
          const listItemToDisable = Array.from(liArray).find(li => li.querySelector('.e-label').textContent === colName);

          listItemToDisable.querySelector('.e-checkbox-wrapper').classList.add('e-checkbox-disabled');
        });
      }

    }.bind(this));
  }

  // Create the RegistrationType dropdown used to show the Legacy or Regulation grid.
  // If the datascope is not eudamed && the 'eu-legacy-data-import' is not enabled, do not create the control.
  CreateRegistrationTypeControl(): void {
    if(this.dataScope && this.dataScope.toLowerCase() === 'eudamed'){
      // Now see if the feature 'eu-legacy-data-import' is enabled
      this.featureService.IsFeatureEnabled('eu-legacy-data-import').subscribe(response => {
        if(response){
          this.isLegacyImportFeatureEnabled = response;
          // Create the list of Registration Types for the dropdown
          let regulationTypes: IRegistrationType[] = [
            { value: RegistrationTypeEnum.Regulation, text: "Regulation", isSelected: true },
            { value: RegistrationTypeEnum.Legacy, text: "Legacy", isSelected: false }
          ];

          this.leadingTab.nativeElement.parentNode.parentNode.style.paddingLeft = '270px';
          // Create parent div container
          let dropdownContainer = document.createElement('div');
          dropdownContainer.id = 'registration-type-dropdown';
          dropdownContainer.className = 'registration-dropdown-container dropdown';

          let label = document.createElement('label');
          label.innerHTML = "Registration Type";

          // Create button
          let button = document.createElement('button');
          button.id = 'registration-dropdown-button';
          button.className = 'btn btn-secondary dropdown-toggle';
          button.type = 'button';
          button.ariaHasPopup = 'true';
          button.ariaExpanded = 'false';
          button.textContent = 'Regulation';
          button.setAttribute('data-bs-toggle', 'dropdown');

          // Create div holder for options
          let divHolder = document.createElement('ul');
          divHolder.className = 'dropdown-menu';

          // Create select
          let select = document.createElement('div');
          select.classList.add("custom-form-select");

          //select

          // Create Options
          regulationTypes.forEach(regulationOption => {
            let li = document.createElement('li');
            let option = document.createElement('a');

            option.text = regulationOption.value.toString();
            option.className = 'dropdown-item'
            option.innerHTML = regulationOption.text.toString();

            option.addEventListener('click', (e: any) => {
              let registrationTypeText = e.target.innerText;
              let selection: any = RegistrationTypeEnum[registrationTypeText]; // Force the conversion to int so that we can properly assign it as the RegistrationTypeEnum type.
              document.getElementById('registration-dropdown-button').textContent = registrationTypeText;
              this.registrationTypeSelection.emit(selection);

            });

            li.appendChild(option);
            divHolder.appendChild(li);
          });

          // Put it all together (based on this: https://getbootstrap.com/docs/4.0/components/dropdowns/)
          dropdownContainer.appendChild(label);
          dropdownContainer.appendChild(button);
          dropdownContainer.appendChild(divHolder);

          this.leadingTab.nativeElement.parentNode.parentNode.appendChild(dropdownContainer);
        }
      });
    }
  }

  load() {

    // Create the Registration Type Control. This control will only appear in Eudamed Data Scope.
    if (!document.getElementById('registration-type-dropdown')) {
      this.CreateRegistrationTypeControl();
    }

    this.grid.on('columnChooserOpened', (e) => {

      if (this.initialLoad) {
        this.initialLoad = false;

        const fields = [];
        this.grid.columns.forEach((col) => {

          let columnDefinition = { field: '', headerText: '' };

          columnDefinition.field = col.field;
          columnDefinition.headerText = col.headerText;
          fields.push(columnDefinition);

        });

        const sortedFields = fields.sort((a, b) => (a.headerText > b.headerText) ? 1 : (a.headerText === b.headerText) ? ((a.size > b.size) ? 1 : -1) : -1)

        const finalcolumns = sortedFields.map((col) => {
          return this.grid.getColumnByField(col.field);
        });

        const checkboxElements = (
          this.grid.columnChooserModule as any
        ).refreshCheckboxList(finalcolumns);

        e.dialog.contentEle.querySelector('.e-innerdiv').style.display = 'none';

        e.dialog.contentEle
          .querySelector('.e-cc-contentdiv')
          .appendChild(checkboxElements);
      }
    });
  }



  failure(e: any) {
    // debugger;
  }

  capitalize(value: string): string {

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  created(event) { }


  /**
     * Triggers when any grid action begins
     * @param  {any} args
     */
  actionBegin(args: any) {

    const type = args.requestType;

    switch (type) {

      default:
        break;
    }
  }

  /**
   * Triggers when any grid action taken (sort, page, rows/per page number)
   * Called from the html actionComplete event
   * @param  {any} args
   */
  complete(args: any) {

    switch (args.requestType) {

      default:
        break;
    }
  }

  checkIsSelected(): boolean {

    this.selectedRecords = this.grid.getSelectedRecords();
    this.selectedRows = this.grid.getSelectedRows();

    if ((this.selectedRows && this.selectedRows.length) && (this.selectedRecords && this.selectedRecords.length)) {
      return true;
    }

    return false;
  }

  toolbarClick(args: ClickEventArgs): void {

    switch (args.item.id) {
      default:
        break;
    }
  }

  persistSelectedRows() {

    this.grid.selectRows([]);

    const selectedItemIndexes: number[] = [];

    const selectedItems = this.storage.read('selectedItems');

    if (selectedItems && selectedItems.length > 0) {

      const gridObj = this.grid;

      const records = gridObj.getCurrentViewRecords();

      selectedItems.forEach(item => {

        const rowIndex = records.findIndex(r => r['id'] === item);

        if (rowIndex >= 0) {
          selectedItemIndexes.push(rowIndex);
        }
      });

      if (selectedItemIndexes.length > 0) {

        this.grid.selectRows(selectedItemIndexes);
      }
    }
  }

  rowSelected(event, field) {

    if (event.isInteracted) {

      if (!this.selectAllChecked) {
        if (event && event.data) {

          // multiple selection
          if (event.data.length) {

            event.data.forEach(item => {
              if (!this.selectedItems.includes(item[field])) {
                this.selectedItems.push(item[field]);
              }
            });

            this.storage.write('selectedItems', this.selectedItems);
          } else {

            if (!this.selectedItems.includes(event.data[field])) {
              this.selectedItems.push(event.data[field]);

              this.storage.write('selectedItems', this.selectedItems);
            }
          }
        }
      }
    }
  }

  rowDeselected(event, field) {

    if (event.isInteracted) {
      if (!this.selectAllChecked) {

        this.selectedItems = this.storage.read('selectedItems');

        if (this.selectedItems && this.selectedItems.length > 0) {

          // multiple selection
          if (event.data.length) {

            event.data.forEach(item => {
              const rowIndex = this.selectedItems.findIndex(x => x === item[field])

              if (rowIndex >= 0) {
                this.selectedItems.splice(rowIndex, 1);
              }
            });
          } else {
            // single item
            const rowIndex = this.selectedItems.findIndex(x => x === event.data[field])

            if (rowIndex >= 0) {
              this.selectedItems.splice(rowIndex, 1);
            }
          }

          this.storage.write('selectedItems', this.selectedItems);
        }
      }
    }
  }

  checkBoxChange(event) {
  }

  selectRowsAll(checked) {

    const rows = this.grid?.getRows();

    const selectChks = this.grid.element.querySelectorAll('.e-checkbox-wrapper');

    if (rows) {

      this.selectedItems = [];
      this.storage.write('selectedItems', this.selectedItems);

      if (checked) {
        this.selectAllChecked = checked;
        this.grid.selectRowsByRange(0, rows.length);
        this.selectedRowsCount = this.deviceCount;

        if (selectChks) {
          selectChks.forEach(chk => {
            chk.classList.add('e-checkbox-disabled');
          });
        }

        this.toastr.info('If "Select All" checkbox is checked, the individual item selection is disabled.', '', { closeButton: true });
      } else {
        // remove items from the persistance array
        this.selectAllChecked = false;
        this.deselectAllChecked = false;
        this.grid.selectRows([]);

        if (selectChks) {
          selectChks.forEach(chk => {
            chk.classList.remove('e-checkbox-disabled');
          });
        }
      }
    }
  }

  selectAll(event) {

    this.selectAllChecked = event.checked;

    // tracking deselect to unselect rows on the "paging" event
    this.deselectAllChecked = !event.checked;

    this.selectRowsAll(this.selectAllChecked);
  }

  getSelectedItemsCount() {

    return this.selectAllChecked ? +this.selectedRowsCount : this.selectedItems.length;
  }

  generateSelectAllCriteria(action: string) {

    let queryCriteria: ISelectAll = <ISelectAll>{};;

    const queryObject = this.grid.getDataModule().generateQuery();

    if (queryObject && queryObject.queries && queryObject.queries.length) {

      queryCriteria.action = action;

      const onWhere = queryObject.queries.find(x => x.fn === 'onWhere');

      // if onWhere Predicate is there, it means there is a filter criteria
      if (onWhere) {

        (queryCriteria as any).query = onWhere?.e;

        if (queryCriteria.query && queryCriteria.query.predicates && queryCriteria.query.predicates.length) {

          queryCriteria.query.predicates.forEach(predicate => {
            delete predicate['comparer'];
          });

        }
      } else {
        // if no onWhere, set an empty ISelectAll
        queryCriteria.query = <IQuery>{};
        queryCriteria.query.predicates = <IPredicate[]>[];
      }
    }

    return queryCriteria;
  }


  storeSelectedItems() {

    // for some reason getSelectedRecords() returns all visible rows, even if nothing is selected
    // however the getSelectedRows() returns correctly the selected rows but not it the structure we need from the getSelectedRecords()
    // So, need to check the getSelectedRows to make sure that rows have been selected. Looks like Syncfusino bug. When any row is really selected,
    // both function return correct number of rows.

    if (this.grid.getSelectedRows() && this.grid.getSelectedRows().length) {
      const selectedRecords = this.grid.getSelectedRecords();

      if (selectedRecords.length > 0) {

        // add selected records
        selectedRecords.forEach(element => {

          if (!this.selectedItems.includes(element['id'])) {
            this.selectedItems.push(element['id']);
          }
        });
      }

      this.storage.write('selectedItems', this.selectedItems);
    } else {

      // when no rows selected the above block is skipped and the storage is not updated and previously selected rows are persisted.
      let storedSelectedItems = this.storage.read('selectedItems');

      // get records on the page and remove each of them from the storage so they are not persisted
      const records = this.grid.getCurrentViewRecords();

      if (records && records.length) {
        records.forEach(item => {

          const rowIndex = storedSelectedItems.findIndex(x => x === item['id']);

          if (rowIndex >= 0) {
            storedSelectedItems.splice(rowIndex, 1)
          }
        });
      }

      // update the storage
      this.storage.write('selectedItems', storedSelectedItems);
    }
  }

  showSFToolTip(event) {

    if (this.isEllipsisActive(event)) {

      if (this.tooltipObj) {
        this.tooltipObj.content = event.target.outerText;
        this.tooltipObj.width = `${ event.target.scrollWidth }px`;

        this.tooltipObj.open();
      }
    }
  }

  hideSFToolTip(event) {

    if (this.tooltipObj) {

      this.tooltipObj.close();
    }
  }


  tooltipValue(args) {
    // here you can get the row data of the target cell
    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {
      const rowInfo = this.grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;

      if (rowData) {
        this.tooltipObj.content = rowData[(rowInfo.column as any)?.field];
        this.tooltipObj.width = `${ args.target.clientWidth }px`;
        this.tooltipObj.cssClass = 'customtooltip';
      }
    }
  }


  // if custom message - override this method in the descendant
  showTooltip(event, headerText) {

    this.tooltipContent = document.createElement('div');

    this.tooltip = new Tooltip({
      content: this.tooltipContent,
      width: '180px',
      cssClass: 'customtooltip',
      enableHtmlParse: false
    });

    const cellValue = event.target.outerText;

    if (cellValue) {

      if (headerText === 'long-contents') {

        this.tooltip.width = `${ cellValue.length * 5.6 }px`;
        this.tooltipContent.innerHTML = cellValue;
      } else {

        this.tooltip.width = '180px';
        if (cellValue) {
          switch (cellValue.toLowerCase()) {
            case 'submission passed':
              this.tooltipContent.innerHTML = ` ${ headerText } - passed successfully.`;
              break;

            case 'submission failed':
              this.tooltipContent.innerHTML = ` ${ headerText } - failed.`;
              break;

            case 'ready for approval':
              this.tooltipContent.innerHTML = ` ${ headerText } - Submission is ready for approval.`;
              break;

            case 'submission approved':
              this.tooltipContent.innerHTML = ` ${ headerText } - Submission is successfully approved.`;
              break;

            case 'system error':
              this.tooltipContent.innerHTML = ` ${ headerText } - System Error occured`;
              break;

            case 'ready for submission':
              this.tooltipContent.innerHTML = ` ${ headerText } - Submission is ready for Approval.`;
              break;

            case 'submission rejected':
              this.tooltipContent.innerHTML = ` ${ headerText } - The item is rejected.`;
              break;

            case 'submission in process':
              this.tooltipContent.innerHTML = ` ${ headerText } - The item is submitted and is in process.`;
              break;

            case 'hung record':
              this.tooltipContent.innerHTML = ` ${ headerText } - No submission results received from the health authority in 24 hours.`;
              break;

              case 'replaced':
                this.tooltipContent.innerHTML = ` ${ headerText } - Submission item was replaced.`;
                break;

            case 'submitted':

              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is accepted by the Health Authority UDI database and is awaiting for the notified body verification (derived)`;
              } else {
                this.tooltipContent.innerHTML = ` ${ headerText } - The item submitted.`;
              }
              break;

            case 'published':

              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is in FDA GUDID and is available for public access (derived)`;
              }
              break;
            case 'unpublished':

              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is in FDA GUDID waiting to be published according to the DI record publish date (derived)`;
              }
              break;

            case 'in grace period':

              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is in FDA GUDID and is in the grace period with all attributes editable except for the DI record publish date  (derived)`;
              }
              break;
            case 'not in gudid':

              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is not in FDA GUDID (derived)`;
              }
              break;

            case 'registered':
              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is registered in the Health Authority UDI database (derived)`;
              } else {
                this.tooltipContent.innerHTML = ` ${ headerText } - The item is registered.`;
              }

              break;

            case 'not registered':

              if (headerText === 'Health Authority Basic UDI-DI State' || headerText === 'Health Authority UDI-DI State') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `DI is not in the Health Authority UDI database (derived)`;
              } else {
                this.tooltipContent.innerHTML = ` ${ headerText } - The item is not registered.`;
              }
              break;

            case 'failed':
              this.tooltipContent.innerHTML = ` ${ headerText } - Submission failed.`;
              break;

            case 'pending model registration':
              this.tooltipContent.innerHTML = ` ${ headerText } - The item is pending registration.`;
              break;
            case 'pending':

              if (headerText === 'file status') {
                this.tooltip.width = `180px`;
                this.tooltipContent.innerHTML = `Your file build is queued.`;
              } else {
                this.tooltipContent.innerHTML = ` ${ headerText } - The file is pending build.`;
              }
              break;
            case 'available':
              this.tooltipContent.innerHTML = ` ${ headerText } - The file is ready for download.`;
              break;
            case 'completed':
              this.tooltip.width = `230px`;
              this.tooltipContent.innerHTML = `Your export file is ready for download.`;
              break;
            case 'exception':
              this.tooltip.width = `160px`;
              this.tooltipContent.innerHTML = `Your export failed. Please run the template again.`;
              break;

            case 'inprocess':
              this.tooltip.width = `160px`;
              this.tooltipContent.innerHTML = `Your file build has begun.`;
              break;
            case 'pass':
              this.tooltip.width = `160px`;
              this.tooltipContent.innerHTML = `Passed Channel Validation`;
              break;
            case 'fail':
              this.tooltip.width = `160px`;
              this.tooltipContent.innerHTML = `Failed Channel Validation`;
              break;
            case 'to be implemented':
              this.tooltip.width = `230px`;
              this.tooltipContent.innerHTML = `Validation for updating Eudamed devices is not implemented yet.`;
              break;
            case 'new':
              this.tooltip.width = `160px`;
              this.tooltipContent.innerHTML = `No submission item created`;
              break;
            case 'current':
              this.tooltip.width = `230px`;
              this.tooltipContent.innerHTML = `Values in Device data fields match values in Current Submission Item`;
              break;
            case 'changed':
              this.tooltip.width = `230px`;
              this.tooltipContent.innerHTML = `Values in Model data fields do not match values in Current Submission Item`;
              break;
          }
        }
      }
      this.tooltip.appendTo(event.target);
    }
  }

  setSelectedRowIndex(e) {
    if (e.type === 'keydown' && (e.which === 13 || e.keyCode === 13)) {
      e.target.click();
    }
  }


  getFilterCriteria(): string {

    let filter = this.storage.read('selectAllFilter');

    if (filter && filter.indexOf('filter=') === -1) {
      filter = '';
    } else {
      filter = filter.replace('&', '?');
    }
    return filter;
  }

  postActionReset() {

    setTimeout(() => {
      this.grid.clearSelection();
      this.selectAllChecked = false;
      this.selectRowsAll(false);
      this.queryCriteria = <ISelectAll>{};
    }, 300);
  }

  clearGridSelection() {

    this.grid.clearSelection();
    this.selectedItems = [];
    this.storage.write('selectedItems', this.selectedItems);
  }

  downloadLogFile(fileName, filePath) {

    if (fileName && filePath) {

      this.exportDataService.getExportFile(fileName, filePath)?.subscribe(response => {

        if (response['size'] && response['type']) {

          // IE
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(response, fileName);
          } else {

            // non-IE
            const URL = window.URL || (<any>window).webkitURL;
            const downloadUrl = URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            link.click();
          }
        } else {

          this.toastr.error(`Error downloading a Log file`, '', { timeOut: 0, closeButton: true });
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // just a util function to see what's on html
  consoleIt(item) {
    console.log(item);
  }
}


